import { useLayoutEffect, useRef } from "react";
import { Minus, Users } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { CommandCenterNavBadge } from "@/components/command-center/CommandCenterNavBadge";
import { useHitlStore } from "@/stores/use-hitl-store";
import { useTeamWorkspaceSession } from "@/stores/use-team-workspace-session";
import { isTeamWorkspacePath } from "@/lib/team-workspace-routes";
import { useTeamWorkspaceNavigation } from "./use-team-workspace-navigation";

export function TeamWorkspaceToggle() {
  const session = useTeamWorkspaceSession();
  const pending = useHitlStore(state => state.pending.size);
  const location = useLocation();
  const expanded = isTeamWorkspacePath(location.pathname);
  const navigate = useNavigate();
  const { requestNavigation } = useTeamWorkspaceNavigation();
  const button = useRef<HTMLButtonElement>(null);
  const wasExpanded = useRef(expanded);
  useLayoutEffect(() => {
    if (wasExpanded.current && !expanded) button.current?.focus();
    wasExpanded.current = expanded;
  }, [expanded]);
  return <button ref={button} type="button" data-team-workspace-toggle aria-label={expanded ? "Minimizar espaço da equipe" : "Abrir espaço da equipe"}
    aria-expanded={expanded} disabled={session.blocked} title={session.draft ? "Espaço da equipe · rascunho preservado" : "Espaço da equipe"}
    onClick={() => requestNavigation(() => navigate(expanded ? session.returnTo : session.workspaceTo, { replace: expanded }))}
    className={(expanded ? "right-6 " : "right-24 md:right-44 ") + "fixed z-40 inline-flex min-h-11 min-w-11 justify-center items-center gap-2 rounded-full border border-app-border bg-app-surface px-3 text-sm font-medium text-brand shadow-premium-sm hover:bg-brand-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand disabled:opacity-50"}
    style={{ bottom: "calc(1.5rem + var(--app-dock-height, 0px) + env(safe-area-inset-bottom, 0px))" }}>
    {expanded ? <Minus className="size-4" aria-hidden /> : <Users className="size-4" aria-hidden />}<span className="hidden md:inline">Espaço da equipe</span>
    {!session.blocked && <CommandCenterNavBadge />}
    {!session.blocked && pending > 0 && <span className="rounded-full bg-brand-soft px-1.5 text-xs tabular-nums" aria-label={`${pending} decisões pendentes`}>{pending > 9 ? "9+" : pending}</span>}
    {session.draft && <span className="size-1.5 rounded-full bg-brand" aria-label="Rascunho preservado" />}
  </button>;
}
